import { render, staticRenderFns } from "./EditResidentialJobModal.vue?vue&type=template&id=b2c24520&"
import script from "./EditResidentialJobModal.vue?vue&type=script&lang=js&"
export * from "./EditResidentialJobModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports